import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/seo-articles';

export default function ArticleCards() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-[1200px] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-primary-300/60 text-sm font-medium text-primary-700 bg-primary-50/80">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            Blog & Guides SEO
          </span>
          <h2 className="mt-5 text-3xl md:text-4xl font-heading font-semibold text-foreground-950 leading-tight">
            Guides & Articles
            <br />
            Hipobuy Spreadsheet
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">
            Découvrez nos articles experts pour maîtriser Hipobuy Spreadsheet et optimiser votre gestion de données.
          </p>
        </div>

        {/* Article Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full h-48 md:h-56 overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span className="flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-calendar-line"></i>
                    </span>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-time-line"></i>
                    </span>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-3 text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                  Lire l&apos;article
                  <span className="w-3.5 h-3.5 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}